import gql from "graphql-tag";

export const API_CREDENTIALS = gql`
  query apiCredentials(
    $where: ApiCredentialWhereInput
    $like: ApiCredentialWhereInput
    $take: Int
    $skip: Int
    $orderBy: [ApiCredentialWhereInput]
  ) {
    apiCredentials(
      where: $where
      like: $like
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      data {
        id
        createdDate
        label
        allowedIps
        enabled
        usageCount
        lastUsedAt
        lastUsedIp
        ownedBy {
          id
          name
        }
      }
      count
    }
  }
`;

export const API_CREDENTIAL = gql`
  query apiCredential($where: ApiCredentialWhereInput) {
    apiCredential(where: $where) {
      id
      label
      allowedIps
      enabled
      usageCount
      lastUsedAt
      lastUsedIp
      ownedBy {
        id
        name
      }
    }
  }
`;

const apiCredentials = { API_CREDENTIALS, API_CREDENTIAL };

export default apiCredentials;
